import * as React from "react";

export interface LoaderProps {
    size?: keyof typeof LoaderDimensions | number;
}

export enum LoaderDimensions {
    small = 20,
    normal = 40,
    large = 80,
}

export const Loader = ({ size = LoaderDimensions.normal }: LoaderProps) => {
    const getDimension = () =>
        typeof size === "number" ? size : LoaderDimensions[size];

    return (
        <img
            className="fa-solid loader"
            data-testid="loader"
            style={{ width: getDimension(), height: getDimension() }}
            src="/icons/loader.svg"
        />
    );
};
